import React, { useEffect, useRef, useState } from "react";
import "../Forgot.scss";

import { FaChevronLeft } from "react-icons/fa";

import CustomButton from "../../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import FormInputField from "../../../components/UserFormComponents/FormInputField/FormInputField";
import { Link, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { requestForgotPassword } from "../../../api/auth";
import { toast } from "react-toastify";
import DesktopLoginContents from "../../../components/DesktopLoginContents/DesktopLoginContents";
import Captcha from "../../../components/Captcha/Captcha";
import { Capacitor } from "@capacitor/core";
import { useSelector } from "react-redux";

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);
  const reRef = useRef(null);

  const user = useSelector((state) => state.userReducer.value);

  useEffect(() => {
    if (user.token) {
      navigate(ROUTES.home.path);
    }
  }, []);

  const handleForgotPassword = async (data) => {
    if (!data?.email) {
      setError("email", { type: "custom", message: "Email required." });
    } else {
      setSubmitting(true);
      let captchaToken = "";
      let source = "";
      if (Capacitor.isNativePlatform()) {
        source = "mobile";
      } else {
        captchaToken = await reRef.current.executeAsync();
      }
      const credentials = {
        email: data?.email,
        captchaToken: captchaToken,
        source: source
      };
      requestForgotPassword(credentials)
        .then((res) => {
          if (res.data?.message) {
            toast.dismiss(); toast.success(res.data?.message);
          } else {
            toast.dismiss(); toast.success("OTP sent successfully.");
          }
          navigate(ROUTES.verifyOTP.path, {
            state: {
              email: data?.email,
              phone: data?.phone,
              resendTimer: res.data?.resend_timer || 60,
            },
          });
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            toast.dismiss(); toast.error(err?.response?.data?.message);
          } else {
            toast.dismiss(); toast.error("OTP sent failed!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };
  return (
    <>
      <Captcha reRef={reRef} />
      <div className="initial-page-contents">
        <div className="forgot-page">
          <form
            onSubmit={handleSubmit(handleForgotPassword)}
            className="form-container"
          >
            <div className="upper">
              <Link to={ROUTES.login.path} className="go-back">
                <FaChevronLeft />
              </Link>
              <div className="heading">
                <p className="title">
                  Forgot <br />
                  <span>Password</span>
                </p>
                <p className="message">
                  Enter your Phone number or email to reset your password.
                </p>
              </div>

              <div className="inputs">
                {/* <FormInputField
              name={"phone"}
              label={"Via SMS"}
              type={"number"}
              iconType={"sms"}
              register={register}
              watch={watch}
              required={false}
              inputErrors={errors}
            /> */}
                <FormInputField
                  name={"email"}
                  label={"Via Email"}
                  type={"email"}
                  iconType={"email"}
                  required={false}
                  watch={watch}
                  register={register}
                  inputErrors={errors}
                />
              </div>
            </div>

            <div className="lower">
              <CustomButton
                name={"Send Code"}
                type={"submit"}
                color={"white reverse"}
                bigButton={true}
                disabled={submitting}
                handleSubmit={() => {}}
                loader={submitting}
              />
              <p className="company-tag">
                &copy; Daikofin <span></span>
                <Link to={ROUTES.contactDUS.path}>Contact</Link>
                <span></span>
                <a href={"https://daikoapp.com/index.php/73-2/"} target="blank">
                  Privacy & terms
                </a>
              </p>
            </div>
          </form>
        </div>
        <DesktopLoginContents />
      </div>
    </>
  );
};

export default ForgotPassword;
